export default __webpack_public_path__ + "dist/media/Templates.051c243a.svg";